export default __webpack_public_path__ + "static/media/Leggings of the Outer Dark.8099d094.jpg";